<div class="courses-area ptb-100 bg-f5f7fa">
    <div class="container">
        <div class="section-title">
            <span class="sub-title">Go at your own pace</span>
            <h2>Fast-Track Your Paramedical Journey Today</h2>
            <p>Join one of the fastest-growing sectors with career-focused paramedical courses. Learn how to assist
                doctors, manage labs, and support patient care.
            </p>
        </div>
        <div class="row">
            <div class="col-lg-6 col-md-6" *ngFor="let item of courseCategoryData">
                <div class="single-courses-box bg-color" (click)="getSubCategory(item)">
                    <div class="courses-image">
                        <a class="d-block image">
                            <img [src]="imageUrl+item.imagePath" alt="image">
                        </a>
                    </div>
                    <div class="courses-content">
                        <h3><a>{{ item.coursesCategoryName }}</a></h3>
                        <p>{{item.coursesCategoryDescription}}</p>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="row">
            <div class="col-lg-6 col-md-12" *ngFor="let item of courseCategoryData">
                <div class="single-courses-item">
                    <div class="row align-items-center">
                        <div class="col-lg-4 col-md-4">
                            <div class="courses-image">
                                <img [src]="imageUrl+item.imagePath" alt="image">
                                <a routerLink="" class="link-btn"></a>
                            </div>
                        </div>
                        <div class="col-lg-8 col-md-8">
                            <div class="courses-content">
                                <a routerLink="." class="fav"><i class="flaticon-heart"></i></a>
                                <span class="price">
                                    <h3><a>{{ item.coursesCategoryName }}</a></h3>
                                </span>
                                <h3><a>
                                        <p>{{item.coursesCategoryDescription}}</p>
                                    </a></h3>
                                <ul class="courses-content-footer d-flex justify-content-between align-items-center">
                                    <li><i class="fa-solid fa-book-bookmark mt-1"></i> 1 Year</li>
                                    <li><i class="fa-solid fa-user-tie mt-1"></i>12th Any Stream Passout</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <div class="shape16"><img src="images/shape15.png" alt="image"></div>
</div>